import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TZyomuinbetuNenpiGetListReq,
  TZyomuinbetuNenpiGetListRes,
} from "./TZyomuinbetuNenpi"

/**
 * 乗務員別燃費に対するAPIリクエスト用サービス
 *
 * @export
 * @class ZyomuinbetuNenpiService
 * @extends {ConnectApi}
 */
export default class ZyomuinbetuNenpiService extends ConnectApi {
  /**
   * 乗務員別燃費一覧取得
   * @param params TZyomuinbetuNenpiGetListReq
   * @returns TApiResponse<TZyomuinbetuNenpiGetListRes>
   */
  getList = async (params: TZyomuinbetuNenpiGetListReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinbetuNenpiGetListRes>> =
        await this.getInner(`/truckcontrol/nenpi/zyomuinmonthlylist`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
